// noinspection DuplicatedCode

import { createApp } from 'vue'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { createI18n } from 'vue-i18n';

//import 'ol/ol.css';
import './index.css'
import router from './router.js';
import {alert_plugin} from 'taxi-lib';

import App from './view/App.vue'

import
  {
    Wait,
    log,
    get_lang,
    get_locales,
    deep_merge,
    vuetify_setup_locale,
    setup_onerror,
    setup_vueonerror,
  } from 'taxi-lib';

const collector_url = 'https://bugs.esyscoder.pl/collect/taxi-receipt/'
setup_onerror(collector_url)
const app = createApp(App)
setup_vueonerror(collector_url, app)

let locales = get_locales()
let lang = get_lang()
log.d('LANG', lang)

import en from './locales/en.json';
import pl from './locales/pl.json';

locales.en = deep_merge(locales.en, en)
locales.pl = deep_merge(locales.pl, pl)

const i18n = createI18n({
    legacy: false, // Use Composition API
    fallbackLocale: 'en',
    locale: lang,
    messages: locales,
});

const vuetify = createVuetify(vuetify_setup_locale(lang))

app
    .use(i18n)
    .use(router)
    .use(vuetify)
    .use(alert_plugin)
    .component('wait', Wait)
    .mount('#app')
